import { getBearerToken } from "../postCall/bearerToken";

/**
 * Gets authorization headers with Bearer token
 * @returns Promise with headers object containing Authorization header
 */
export const getAuthHeaders = async (): Promise<Record<string, string>> => {
  const token = await getBearerToken();
  return {
    Authorization: `Bearer ${token}`,
  };
};

/**
 * Creates request options for POST API calls
 * @param body - Request body object
 * @param header - Optional additional headers
 * @param signal - Optional AbortSignal for canceling the request
 * @returns RequestInit object with configured options
 */
export const createRequestOptions = (
  body: Record<string, unknown>,
  header?: Record<string, string>,
  signal?: AbortSignal,
): RequestInit => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  if (header) {
    for (const key in header) {
      headers.append(key, header[key]);
    }
  }

  const options: RequestInit = {
    method: "POST",
    headers,
    redirect: "follow",
    body: JSON.stringify(body),
    signal,
  };

  return options;
};

/**
 * Handles API response and throws detailed errors if response is not ok
 * @param response - Fetch API Response object
 * @returns Promise with parsed JSON response
 * @throws Error with HTTP status and response body if response is not ok
 */
export const handleApiResponse = async (response: Response): Promise<any> => {
  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(
      `HTTP error! Status: ${response.status}, Body: ${errorBody}`,
    );
  }
  return await response.json();
};
